import { Routes, Route } from 'react-router-dom';

// Auth feature imports
import HomePage from './features/auth/pages/Home';

// Dashboard feature imports
import MainAccountantDashboard from './features/dashboard/pages/Main_Accountant';

// Customer feature imports
import HariltsagchPage from './features/customers/pages/HariltsagchPage';
import CustomersTaxInvoiceList from './features/customers/pages/CustomersTaxInvoicList';
import Salary from './features/customers/pages/Salary';

// User management feature imports
import AccountantUserPage from './features/users/pages/AccountantUserPage';

// Reports feature imports

import EBarimtPage from './features/reports/pages/EBarimtPage';
import TaxGetHistoryPage from './features/customers/pages/TaxGetHistory';
import TaxGetListPage from './features/customers/pages/TaxGetList';
import PurchaseReceiptsPage from './features/customers/pages/Ebarimt/purchase';
import SalesReceiptsPage from './features/customers/pages/Ebarimt/Sales';
import ExcelUploadPage from './features/customers/pages/Ebarimt/ExcelUpload';
import TaxfreeExcelUploadPage from './features/customers/pages/Ebarimt/Create_TaxfreeExcelUpload';
import SummaryPeriodPage from './features/customers/pages/Ebarimt/SummaryPeriod';
import SummaryYearPage from './features/customers/pages/Ebarimt/SummaryYear';
import TaxPostHHOATPage from './features/customers/pages/TaxPostHHOAT';
import InsuranceGetHistoryReportPage from './features/customers/pages/Insurance/InsuranceGetHistoryReport';
import AccountPeriodBalancePage from './features/Finance/pages/AccountPeriodBalance';
import LedgerPage from './features/Finance/pages/Ledger';
import AccountPeriodClosePage from './features/Finance/AccountPeriodCloset/AccountPeriodClose';
import CashflowStatementPage from './features/Finance/pages/CashflowStatement';

// Admin feature imports
import AdminMainPage from './features/admin/pages/AdminMainPage';
import AdminHariltsagchPage from './features/admin/pages/AdminHariltsagchPage';
import AdminAccountantPage from './features/admin/pages/AdminAccountantPage';
import AdminAppUserPage from './features/admin/pages/AdminAppUserPage';
import BusinessCustomerPage from './features/admin/pages/BusinessCustomer';
import NoLedgerTransactionListPage from './features/admin/pages/Barimt/NoLedgerTransactionList';
import TemplateLedgerPage from './features/admin/pages/TemplateLedgerPage';

// Shared component imports
import Settings from './shared/components/Settings';
import ProtectedRoute from './shared/components/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Public route - Login page */}
      <Route path="/" element={<HomePage />} />
      
      {/* Protected routes - require authentication */}
      <Route path="/customers" element={
        <ProtectedRoute>
          <MainAccountantDashboard />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant" element={
        <ProtectedRoute>
          <MainAccountantDashboard />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/customers" element={
        <ProtectedRoute>
          <HariltsagchPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/salary" element={
        <ProtectedRoute>
          <Salary />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/app-user" element={
        <ProtectedRoute>
          <AccountantUserPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/accountant" element={
        <ProtectedRoute>
          <AdminAccountantPage />
        </ProtectedRoute>
      } />
   
      <Route path="/main_accountant/e-barimt" element={
        <ProtectedRoute>
          <EBarimtPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/Purchase" element={
        <ProtectedRoute>
          <PurchaseReceiptsPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/Sales" element={
        <ProtectedRoute>
          <SalesReceiptsPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/ExcelUpload" element={
        <ProtectedRoute>
          <ExcelUploadPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/TaxfreeExcelUpload" element={
        <ProtectedRoute>
          <TaxfreeExcelUploadPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/no-ledger-transaction-list" element={
        <ProtectedRoute>
          <NoLedgerTransactionListPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/summary-month" element={
        <ProtectedRoute>
          <SummaryPeriodPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/summary-year" element={
        <ProtectedRoute>
          <SummaryYearPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/TaxGetHistory" element={
        <ProtectedRoute>
          <TaxGetHistoryPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/TaxGetList" element={
        <ProtectedRoute>
          <TaxGetListPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/tax-invoice-balance" element={
        <ProtectedRoute>
          <CustomersTaxInvoiceList />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/tax-post-hhoat" element={
        <ProtectedRoute>
          <TaxPostHHOATPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/insurance-report-summary" element={
        <ProtectedRoute>
          <InsuranceGetHistoryReportPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/account-period-balance" element={
        <ProtectedRoute>
          <AccountPeriodBalancePage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/ledger" element={
        <ProtectedRoute>
          <LedgerPage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/account-period-close" element={
        <ProtectedRoute>
          <AccountPeriodClosePage />
        </ProtectedRoute>
      } />
      <Route path="/main_accountant/cashflow" element={
        <ProtectedRoute>
          <CashflowStatementPage />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel" element={
        <ProtectedRoute>
          <AdminMainPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/hariltsagch" element={
        <ProtectedRoute>
          <AdminHariltsagchPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/business-customer" element={
        <ProtectedRoute>
          <BusinessCustomerPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/no-ledger-transaction-list" element={
        <ProtectedRoute>
          <NoLedgerTransactionListPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/app-user" element={
        <ProtectedRoute>
          <AdminAppUserPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/accountant" element={
        <ProtectedRoute>
          <AdminAccountantPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/salary" element={
        <ProtectedRoute>
          <Salary />
        </ProtectedRoute>
      } />
  
      <Route path="/HomeScreen_AdminPanel/e-barimt" element={
        <ProtectedRoute>
          <EBarimtPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/Purchase" element={
        <ProtectedRoute>
          <PurchaseReceiptsPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/Sales" element={
        <ProtectedRoute>
          <SalesReceiptsPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/ExcelUpload" element={
        <ProtectedRoute>
          <ExcelUploadPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/TaxfreeExcelUpload" element={
        <ProtectedRoute>
          <TaxfreeExcelUploadPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/summary-month" element={
        <ProtectedRoute>
          <SummaryPeriodPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/summary-year" element={
        <ProtectedRoute>
          <SummaryYearPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/summary-month" element={
        <ProtectedRoute>
          <SummaryPeriodPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/Sales" element={
        <ProtectedRoute>
          <SalesReceiptsPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/business-categories" element={
        <ProtectedRoute>
          <AdminMainPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/tax-invoice-balance" element={
        <ProtectedRoute>
          <CustomersTaxInvoiceList />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/tax-post-hhoat" element={
        <ProtectedRoute>
          <TaxPostHHOATPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/insurance-report-summary" element={
        <ProtectedRoute>
          <InsuranceGetHistoryReportPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/account-period-balance" element={
        <ProtectedRoute>
          <AccountPeriodBalancePage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/ledger" element={
        <ProtectedRoute>
          <LedgerPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/account-period-close" element={
        <ProtectedRoute>
          <AccountPeriodClosePage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/cashflow" element={
        <ProtectedRoute>
          <CashflowStatementPage />
        </ProtectedRoute>
      } />
      <Route path="/HomeScreen_AdminPanel/template-ledger" element={
        <ProtectedRoute>
          <TemplateLedgerPage />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
